// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetPassword_wrapper__FgeUz","button":"ResetPassword_button__Ipxy4"};